export var MeshTopology;
(function (MeshTopology) {
    MeshTopology[MeshTopology["Points"] = 0] = "Points";
    MeshTopology[MeshTopology["Lines"] = 1] = "Lines";
    MeshTopology[MeshTopology["LineLoop"] = 2] = "LineLoop";
    MeshTopology[MeshTopology["LineStrip"] = 3] = "LineStrip";
    MeshTopology[MeshTopology["Triangles"] = 4] = "Triangles";
    MeshTopology[MeshTopology["TriangleStrip"] = 5] = "TriangleStrip";
    MeshTopology[MeshTopology["TriangleFan"] = 6] = "TriangleFan";
})(MeshTopology || (MeshTopology = {}));
